import InfiniteScrollTable from '@app/components/InfiniteScrollTable'
import { IEarnestMoneySummary } from '@app/models/EarnestMoneySummary'
import { bindFunctions } from '@app/utils/class'
import { formatCurrency, formatDate } from '@app/utils/formatting'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { Column } from 'react-virtualized'
import {
  actionCreators,
  IEarnestMoneyListState,
} from '../modules/earnestMoneyList'

type ComponentProps = IEarnestMoneyListState & typeof actionCreators

export default class EarnestMoneyListPage extends React.PureComponent<ComponentProps> {
  private tableRef: React.RefObject<InfiniteScrollTable>

  constructor(props: ComponentProps) {
    super(props)

    bindFunctions(this)

    this.tableRef = React.createRef<InfiniteScrollTable>()
  }

  public render() {
    const totalHolding = this.props.items.reduce((total, item: any) => {
      return total + item.amount
    }, 0)

    return (
      <DocumentTitle title='Admin - Earnest Money Summary'>
        <div className='container d-flex flex-column h-100 pt-3'>
          <div>
            <h3>Earnest Money Holding Summary</h3>
            <div style={{ fontWeight: 'bold' }}>
              Total Holding: {formatCurrency(totalHolding, 2)}
            </div>
          </div>
          <div className='mt-4'>
            <InfiniteScrollTable
              isLoading={this.props.isLoading}
              items={this.props.items}
              loadItems={this.props.loadEarnestMoney}
              noRowsRenderer={this._noRowsRenderer}
              onRowClicked={this._onRowClicked}
              totalItems={this.props.totalItems}
              ref={this.tableRef}
            >
              <Column
                cellDataGetter={({ rowData }) => {
                  const holdings = rowData as IEarnestMoneySummary
                  return holdings.pipelineName
                }}
                dataKey='pipeline'
                flexGrow={1}
                label='Pipeline'
                width={100}
              />
              <Column
                cellDataGetter={({ rowData }) => {
                  const holdings = rowData as IEarnestMoneySummary
                  return holdings.location
                }}
                dataKey='heldAt'
                flexGrow={1}
                label='Held At'
                width={100}
              />
              <Column
                cellDataGetter={({ rowData }) => {
                  const holdings = rowData as IEarnestMoneySummary
                  return holdings.depositDate
                    ? formatDate(holdings.depositDate, 'MM/DD/YYYY')
                    : null
                }}
                dataKey='depositDate'
                label='Deposited'
                width={100}
              />
              <Column
                cellDataGetter={({ rowData }) => {
                  const holdings = rowData as IEarnestMoneySummary
                  return formatCurrency(holdings.amount, 2)
                }}
                dataKey='amount'
                label='Amount'
                width={100}
              />
            </InfiniteScrollTable>
          </div>
        </div>
      </DocumentTitle>
    )
  }

  private _noRowsRenderer() {
    return <div>No earnest money holdings</div>
  }

  private _onRowClicked(item: IEarnestMoneySummary, index: number) {
    window.alert(`Clicked on ${item.location}`)
  }

  private _onChangeFilter(newFilter: string) {
    this.props.setFilterText(newFilter)
    this._reloadData()
  }

  private _reloadData() {
    if (this.tableRef.current) {
      this.tableRef.current.forceReloadData()
    }
  }
}
